// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"538":"css/email/app","776":"css/front/app"}[chunkId] + ".css";
};